var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"congestion-area"},[_c('div',{staticClass:"row"},_vm._l((_vm.spotExList),function(item,index){return _c('ImageVertical',{key:index,attrs:{"img":item.img,"text":item.text,"selected":_vm.checkSelected(item.text)},on:{"click-image":_vm.onSelect}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc91838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/SpotExamples.vue
// module id = null
// module chunks = 